export const PRESETS = [
  {
    h: 1,
    p: 0.5,
    k: 2.5,
    k2: 2.01,
    delta: 0.04,
    maxLoops: 1
  },
  {
    h: 1,
    p: 0.5,
    k: 0.996,
    k2: 2.01,
    delta: 0.04,
    maxLoops: 5
  },
  {
    h: 0,
    p: 1.934,
    k: 2.394,
    k2: 1.584,
    delta: 0.04,
    maxLoops: 1
  },
  {
    h: 2.5,
    p: 0.5,
    k: 0.804,
    k2: 4.608,
    delta: 0.04,
    maxLoops: 3
  },
  {
    h: 1.3,
    p: 0.31702,
    k: 0.476,
    k2: 1.894,
    delta: 0.023,
    maxLoops: 3
  },
  {
    h: 0.325,
    p: 0.31702,
    k: 0.476,
    k2: 1.894,
    delta: 0.023,
    maxLoops: 6
  },
  {
    h: 1.5,
    p: 0.31565656565656564,
    k: 0.4594004823705065,
    k2: 1.8939393939393938,
    delta: 0.023,
    maxLoops: 5
  },
  {
    h: 2.975,
    p: 0.7052186177715092,
    k: 0.6909656244601831,
    k2: 2.01,
    delta: 0.04,
    maxLoops: 6
  },
  {
    h: 4.325,
    p: 1.1587485515643106,
    k: 1.0465724751439038,
    k2: 1.1587485515643103,
    delta: 0.03,
    maxLoops: 9
  },
  {
    h: 1.5,
    p: 0.31565656565656564,
    k: 0.4594004823705065,
    k2: 0.9640877319836104,
    delta: 0.023,
    maxLoops: 5
  },
  {
    h: 1.1,
    p: 0.36363636363636365,
    k: 0.47619047619047616,
    k2: 1.8912529550827424,
    delta: 0.023,
    maxLoops: 4
  },
  {
    h: 3,
    p: 0.19809825673534073,
    k: 1.0512483574244416,
    k2: 0.5458515283842794,
    delta: 0.04,
    maxLoops: 2
  },
  {
    h: 3,
    p: 0.19809825673534073,
    k: 1.0512483574244416,
    k2: 0.7446016381236039,
    delta: 0.04,
    maxLoops: 2
  },
  {
    h: 1.1,
    p: 0.1522301720200944,
    k: 1.0512483574244416,
    k2: 0.5649717514124294,
    delta: 0.04,
    maxLoops: 2
  },
  {
    h: 1.8,
    p: -0.32247662044501774,
    k: 1.0482180293501049,
    k2: 0.28216704288939054,
    delta: 0.04,
    maxLoops: 6
  },
  {
    h: 1.6,
    p: -0.32247662044501774,
    k: 0.2782415136338342,
    k2: 0.4043671653861706,
    delta: 0.04,
    maxLoops: 8
  },
  {
    h: 0,
    p: 0.6013229104028863,
    k: 0.4022526146419952,
    k2: 0.31338138514572234,
    delta: 0.04,
    maxLoops: 12
  },
  {
    h: 2.7,
    p: 0.5,
    k: 2.5,
    k2: 0.46882325363338023,
    delta: 0.04,
    maxLoops: 4,
  },
  {
    h: 0.5,
    p: 0.5,
    k: 2.5,
    k2: 0.46816479400749067,
    delta: 0.04,
    maxLoops: 4,
  },
  {
    h: 0.4,
    p: 0.4,
    k: 1.4285714285714286,
    k2: 0.5002501250625313,
    delta: 0.04,
    maxLoops: 7,
  },
  {
    h: 0.4,
    p: 0.12140342357654486,
    k: 2.3923444976076556,
    k2: 3.5587188612099645,
    delta: 0.005,
    maxLoops: 1,
  }
];
